import { jsx as f } from "react/jsx-runtime";
import { c as i } from "react/compiler-runtime";
import { FormControlLabel as n } from "@mui/material";
import { forwardRef as p } from "react";
const C = p((m, a) => {
  const e = i(11);
  let t, o;
  e[0] !== m ? ({
    sx: o,
    ...t
  } = m, e[0] = m, e[1] = t, e[2] = o) : (t = e[1], o = e[2]);
  let l;
  e[3] !== o ? (l = Array.isArray(o) ? o : [o], e[3] = o, e[4] = l) : l = e[4];
  let r;
  e[5] !== l ? (r = [x.defaultStyles, ...l], e[5] = l, e[6] = r) : r = e[6];
  let s;
  return e[7] !== t || e[8] !== a || e[9] !== r ? (s = /* @__PURE__ */ f(n, { ref: a, sx: r, ...t }), e[7] = t, e[8] = a, e[9] = r, e[10] = s) : s = e[10], s;
}), x = {
  defaultStyles: {
    ml: 0,
    gap: "8px",
    userSelect: "none",
    ".MuiFormControlLabel-label": {
      fontSize: "12px",
      fontWeight: 400
    }
  }
};
export {
  C as FormControlLabel
};
